import { useToggle } from 'shared/hooks';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { PrimaryButton, SecondaryButton } from 'ogp/providers/dialog-provider';
import { useTranslation } from 'react-i18next';

export const useQrCodeDownloadGuideDialog = ({ onDownload }: { onDownload: () => void }) => {
  const { t } = useTranslation('web-common');
  const { on: isDialogOpen, setOn: openDialog, setOff: closeDialog } = useToggle(false);

  const handleDownload = () => {
    onDownload();
    closeDialog();
  };

  const Element = (
    <Dialog onClose={closeDialog} open={isDialogOpen}>
      <DialogTitle>{t('qrcode_instruction.title')}</DialogTitle>
      <DialogContent>
        <p>{t('qrcode_instruction.subtitle')}</p>
        <p>{t('qrcode_instruction.step_one')}</p>
        <p>{t('qrcode_instruction.step_two')}</p>
        <p>{t('qrcode_instruction.step_three')}</p>
        <p>{t('qrcode_instruction.note')}</p>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-around' }}>
        <SecondaryButton onClick={closeDialog}>{t('buttons.cancel')}</SecondaryButton>
        <PrimaryButton onClick={handleDownload}>{t('qrcode_instruction.download')}</PrimaryButton>
      </DialogActions>
    </Dialog>
  );

  return { Element, open: openDialog, close: closeDialog };
};
